import { Component, OnInit, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { PermissionDialogComponent } from 'path-shared/components/permission-dialog/permission-dialog.component';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { Builder } from 'path-shared/models/builder';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { NotificationService } from 'path-shared/services/notification/notification.service';
import { MaquinasTableComponent } from '../components/maquinas-table/maquinas-table.component';
import { MaquinasEditorComponent } from '../components/maquinas-editor/maquinas-editor.component';
import { MaquinasFilter } from '../models/maquina-filter';
import { MaquinasFilterComponent } from '../components/maquinas-filter/maquinas-filter.component';

@Component({
  selector: 'app-maquinas',
  templateUrl: './maquinas.component.html',
  styleUrls: ['./maquinas.component.scss']
})
export class MaquinasComponent implements OnInit {

  permissionDialogRef: MatDialogRef<PermissionDialogComponent>;
  activeFilters: string[] = [];
  filterData: MaquinasFilter;
  somIdFoo: number;
  dataDialog: ComponentDialog = Builder.newComponentDialog();

  @ViewChild(MaquinasTableComponent) maquinasTable: MaquinasTableComponent;
  constructor(
    private dialog: MatDialog,
    public auth: AuthorizationService,
    private i18n: I18n,
    private not: NotificationService,
    public thisDialogRef: MatDialogRef<MaquinasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
  ) {
    this.filterData = new MaquinasFilter('id', 'desc');
    if (data !== undefined) {
      this.dataDialog = data;
    }
  }

 

  ngOnInit() {
    this.auth.UserCanSeePage(this.auth.Pages.Maquinas);
    this.maquinasTable.itemClicked.subscribe(secure_id => {
      this.update(secure_id);
    });
    this.maquinasTable.itemSelected.subscribe(codi => {
      this.thisDialogRef.close(codi);
    });
  }

  ngAfterViewInit() {
    if (!this.dataDialog.isDialog) {
      this.not.titleChange(this.i18n('Maquinas'));
    }
  }

  edit() {
    const idSeleccionat: string = this.maquinasTable.displayedItems['checkedItems'][0];
    this.update(idSeleccionat);
  }

  create() {
    this.update(null);
  }

  update(secure_id: string) {
    const data: ComponentDialog = Builder.newComponentDialog(true, false, secure_id);

    const ref = this.dialog.open(MaquinasEditorComponent, {
      width: '70%',
      closeOnNavigation: false,
      autoFocus: true,
      data: data
    });

    ref.afterClosed().subscribe(updated => {
      if (updated) { this.maquinasTable.load(); }
    });
  }

  refresh() {
    this.maquinasTable.load();
  }

  onFilterClicked() {
    const ref = this.dialog.open(MaquinasFilterComponent, {
      width: '50%',
      closeOnNavigation: false,
      autoFocus: true,
      data: {
        'filter': this.maquinasTable.filter
      }
    });

    ref.componentInstance.notify.subscribe((filter: MaquinasFilter) => {
      this.maquinasTable.filter.set(filter);
      this.maquinasTable.load();
    });
  }

  onRowSelected(somid) {
    this.update(somid);
  }

  generateExcel() {
    this.maquinasTable.generateExcel();
  }

}
